import React from "react";

export default function RecomendacionesDieteticasNectar() {
  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Recomendaciones dietéticas características de la viscosidad néctar</h4>
      </div>

      {/* Texto + descargable */}
      <div className="flex flex-col gap-4 mt-2">

        {/* Recomendaciones */}
        <div className="bg-[#f4f8fc] p-6 rounded-lg shadow">
          <div className="text-justify space-y-4">
            <p>Este tipo de líquido tiene una consistencia más espesa que el agua (líquido fino), pero más ligera que la miel y al decantarlo de una cuchara se derrama con rapidez, aunque de forma más lenta que el agua.</p>

            <hr className="border-gray-300" />

            <p>Al verterlo, forma un hilo fino.</p>

            <hr className="border-gray-300" />

            <p>Puede succionarse con una pajita de tamaño estándar. No obstante, recuerde que esto NO es recomendable.</p>
          </div>
        </div>

        {/* Recuerde */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="text-justify font-semibold mb-4">
            RECUERDE:
          </p>

          <ol className="text-justify list-decimal list-inside space-y-2">
            <li>El profesional de la salud deberá evaluar las necesidades específicas del paciente y determinar la viscosidad más adecuada y segura.</li>
            <li>Uso de espesantes: para alcanzar la viscosidad néctar, se pueden utilizar módulos espesantes que ayudan a modificar la consistencia de los líquidos de forma segura.</li>
          </ol>
        </div>

        {/* Descargable */}
        <div className="flex items-center">
          <p className="text-justify gap-4 mt-2 mb-4">
            Si desea obtener el descargable, pulse en el siguiente{" "}
            <a
              href="/docs/recomendaciones-dieteticas-nectar.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
            enlace
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}